import { render } from "./DetailInvestment.vue?vue&type=template&id=697de674&scoped=true"
import script from "./DetailInvestment.vue?vue&type=script&lang=js"
export * from "./DetailInvestment.vue?vue&type=script&lang=js"

import "./DetailInvestment.vue?vue&type=style&index=0&id=697de674&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697de674"]])

export default __exports__